import { iconHome, iconLesson, iconUser } from "assets/images";
import "./styles.scss";
import { Avatar, Button } from "@mui/material";
import RoutePaths from "routes/RoutePaths";
import { useHistory } from "react-router-dom";
import { col1img, col2img, col3img } from 'assets/images';
import { useTranslation } from "react-i18next";

const RegSteps = () => {
  const { push } = useHistory();
  const { t } = useTranslation();
  return (
    <div className="reg-steps">
      <div className="step-single">
        <Avatar alt="" src={col1img} />
        <div className="step-no">STEP.1</div>
        <div className="step-title">{t("teacherRegisterInfo.stepArea.step1.title")}</div>
        <p className="step-para">
          {t("teacherRegisterInfo.stepArea.step1.description")}
        </p>
      </div>
      <div className="step-single">
        <Avatar alt="" src={col2img} />
        <div className="step-no">STEP.2</div>
        <div className="step-title">{t("teacherRegisterInfo.stepArea.step2.title")}</div>
        <p className="step-para loose">
          {t("teacherRegisterInfo.stepArea.step2.description")}
        </p>
      </div>
      <div className="step-single">
        <Avatar alt="" src={col3img} />
        <div className="step-no">STEP.3</div>
        <div className="step-title">{t("teacherRegisterInfo.stepArea.step3.title")}</div>
        <p className="step-para loose">
          {t("teacherRegisterInfo.stepArea.step3.description")}
        </p>
      </div>
    </div>
  );
};

export default RegSteps;
